import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useAuth } from "@/contexts/AuthContext";
import { EmailPasswordForm } from "@/components/auth/EmailPasswordForm";

const GoogleIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.1A6.6 6.6 0 0 1 5.5 12c0-.73.13-1.44.34-2.1V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
  </svg>
);

const ModeTab = ({ active, onClick, testid, children }) => (
  <button
    type="button"
    data-testid={testid}
    onClick={onClick}
    className={`flex-1 py-3.5 font-mono text-[11px] uppercase tracking-widest transition-colors ${
      active ? "text-[#cfff04] border-b-2 border-[#cfff04]" : "text-[#d0d0d0] hover:text-white"
    }`}
  >
    {children}
  </button>
);

export default function AuthModal({ open, onOpenChange, onAuthed }) {
  const { setUser, login } = useAuth();
  const [mode, setMode] = useState("signin"); // signin | signup

  const onSuccess = (data) => {
    setUser(data);
    onAuthed?.(data);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="auth-modal"
        className="bg-[#121212] border border-[#3a3a3a] text-white rounded-none sm:max-w-sm p-0 gap-0"
      >
        <div className="flex border-b border-[#3a3a3a]">
          <ModeTab active={mode === "signin"} onClick={() => setMode("signin")} testid="auth-tab-signin">
            Sign in
          </ModeTab>
          <ModeTab active={mode === "signup"} onClick={() => setMode("signup")} testid="auth-tab-signup">
            Create account
          </ModeTab>
        </div>

        <div className="p-6">
          <DialogTitle className="font-display font-black text-2xl uppercase tracking-tighter mb-1">
            {mode === "signin" ? "Welcome back." : "Join SolSpur."}
          </DialogTitle>
          <DialogDescription className="font-mono text-[11px] uppercase tracking-widest text-[#d0d0d0] mb-5">
            {mode === "signin" ? "Sign in with email or Google" : "Free account · launch coins · track stats"}
          </DialogDescription>

          <EmailPasswordForm key={mode} mode={mode} onSuccess={onSuccess} />

          <div className="relative flex items-center gap-3 my-5">
            <div className="flex-1 h-px bg-[#222]" />
            <span className="font-mono text-[11px] text-[#d0d0d0] uppercase tracking-widest">or</span>
            <div className="flex-1 h-px bg-[#222]" />
          </div>

          <button
            type="button"
            onClick={login}
            data-testid="auth-google-btn"
            className="w-full flex items-center justify-center gap-2 border border-[#333] hover:border-[#cfff04] transition-colors font-mono text-[11px] uppercase tracking-wider text-[#efefef] py-3"
          >
            <GoogleIcon />
            Continue with Google
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
